
    import './styles.scoped.css';
    export default {
  "drawer": "awsui_drawer_12i0j_1gyy2_189",
  "with-expanded-motion": "awsui_with-expanded-motion_12i0j_1gyy2_203",
  "legacy": "awsui_legacy_12i0j_1gyy2_217",
  "ai-drawer": "awsui_ai-drawer_12i0j_1gyy2_217",
  "bottom-drawer": "awsui_bottom-drawer_12i0j_1gyy2_217",
  "last-opened": "awsui_last-opened_12i0j_1gyy2_225",
  "drawer-global": "awsui_drawer-global_12i0j_1gyy2_229",
  "drawer-expanded": "awsui_drawer-expanded_12i0j_1gyy2_238",
  "drawer-hidden": "awsui_drawer-hidden_12i0j_1gyy2_242",
  "has-next-siblings": "awsui_has-next-siblings_12i0j_1gyy2_252",
  "global-drawer-wrapper": "awsui_global-drawer-wrapper_12i0j_1gyy2_252",
  "drawer-content-container": "awsui_drawer-content-container_12i0j_1gyy2_266",
  "drawer-gap": "awsui_drawer-gap_12i0j_1gyy2_269",
  "drawer-close-button": "awsui_drawer-close-button_12i0j_1gyy2_287",
  "drawer-expanded-mode-button": "awsui_drawer-expanded-mode-button_12i0j_1gyy2_293",
  "drawer-content": "awsui_drawer-content_12i0j_1gyy2_266",
  "drawer-content-hidden": "awsui_drawer-content-hidden_12i0j_1gyy2_305",
  "drawer-slider": "awsui_drawer-slider_12i0j_1gyy2_308",
  "drawer-actions": "awsui_drawer-actions_12i0j_1gyy2_360",
  "ai-drawer-slider-handle": "awsui_ai-drawer-slider-handle_12i0j_1gyy2_417",
  "drawer-content-header": "awsui_drawer-content-header_12i0j_1gyy2_436",
  "drawer-content-header-content": "awsui_drawer-content-header-content_12i0j_1gyy2_449",
  "drawer-back-to-console-slot": "awsui_drawer-back-to-console-slot_12i0j_1gyy2_466",
  "drawer-back-to-console-button-wrapper": "awsui_drawer-back-to-console-button-wrapper_12i0j_1gyy2_505",
  "drawer-back-to-console-button": "awsui_drawer-back-to-console-button_12i0j_1gyy2_505",
  "drawer-back-to-console-custom-button": "awsui_drawer-back-to-console-custom-button_12i0j_1gyy2_578",
  "drawer-content-content": "awsui_drawer-content-content_12i0j_1gyy2_584",
  "bottom-drawer-content-header": "awsui_bottom-drawer-content-header_12i0j_1gyy2_642",
  "bottom-drawer-content-header-content": "awsui_bottom-drawer-content-header-content_12i0j_1gyy2_649",
  "bottom-drawer-actions": "awsui_bottom-drawer-actions_12i0j_1gyy2_657",
  "runtime-feature-notifications-drawer-content": "awsui_runtime-feature-notifications-drawer-content_12i0j_1gyy2_665",
  "runtime-feature-notifications-footer": "awsui_runtime-feature-notifications-footer_12i0j_1gyy2_669"
};
  